import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import { Field, Formik, FormikActions, FormikProps } from "formik";
import React, { useState } from "react";
import { connect } from "react-redux";
import voca from "voca";
import * as Yup from "yup";
import SnackMessage from "../../../componentes/SnakBar";
import {
  GetPainelCadastroDocument,
  GetPainelCadastroQuery,
  SavePainelCadastroTaxaProps,
  withSavePainelCadastroTaxa
} from "../../../graphql/components";
import { IState } from "../../../redux/reducers";
import FormikCurrencyInput from "../../../componentes/MaskedInput/FormikCurrencyInput";

const Transition = React.forwardRef<unknown, React.ComponentProps<typeof Slide>>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as React.ComponentProps<typeof Slide>)} />;
});

const Schema = Yup.object().shape({
  taxaCredito: Yup.string().nullable(true),
  taxaCredito0a6: Yup.string().nullable(true),
  taxaCredito7a12: Yup.string().nullable(true),
  taxaDebito: Yup.string().nullable(true),
  taxaTicket: Yup.string().nullable(true)
});

interface Props {
  open: boolean;
  handleClose: () => void;
  mensagemRetorno: (msg: boolean) => void;
  nomeOperadora: string | undefined;
  codOperadora: number | undefined;
  taxaCredito?: number | undefined;
  taxaCredito0a6?: number | undefined;
  taxaCredito7a12?: number | undefined;
  taxaDebito?: number | undefined;
  taxaTicket?: number | undefined;
}

const CadastrarTaxas = ({
  open,
  handleClose,
  mensagemRetorno,
  nomeOperadora,
  codOperadora,
  mutate
}: SavePainelCadastroTaxaProps<Props>) => {
  const [message, setMessage] = useState("");
  const [openSnackMessage, setOpenSnackMessage] = useState(false);
  const [variantSnack, setVariantSnack] = useState<"success" | "warning" | "error" | "info">("success");

  const closeSnackMessage = () => {
    setOpenSnackMessage(false);
  };

  const save = async (values: FormValues, actions: FormikActions<FormValues>) => {
    try {
      let response = await mutate!({
        refetchQueries: [
          {
            query: GetPainelCadastroDocument
          }
        ],
        variables: {
          values: {
            codOperadora: codOperadora,
            taxaCredito: parseFloat(voca.replaceAll(voca.replaceAll(values.taxaCredito, ".", ""), ",", ".")),
            taxaCredito0a6: parseFloat(voca.replaceAll(voca.replaceAll(values.taxaCredito0a6, ".", ""), ",", ".")),
            taxaCredito7a12: parseFloat(voca.replaceAll(voca.replaceAll(values.taxaCredito7a12, ".", ""), ",", ".")),
            taxaDebito: parseFloat(voca.replaceAll(voca.replaceAll(values.taxaDebito, ".", ""), ",", ".")),
            taxaTicket: parseFloat(voca.replaceAll(voca.replaceAll(values.taxaTicket, ".", ""), ",", "."))
          }
        },
        update: (store, result) => {
          const data: GetPainelCadastroQuery | null = store.readQuery({ query: GetPainelCadastroDocument });
          const registro = data!.getPainelCadastro
            .filter(item => item.operadora!.codoperadora! === codOperadora!)
            .map(item => {
              item.statusTaxa.descricao! = "aprovado";
              return item;
            });
          store.writeQuery({
            query: GetPainelCadastroDocument,
            data: registro,
            variables: {}
          });
        }
      });
      if (response) {
        if (
          response.data!.savePainelCadastroTaxa === "PAINEL_CADASTRO" ||
          response.data!.savePainelCadastroTaxa === "PROCESSO_CONCLUIDO"
        ) {
          handleClose();
          mensagemRetorno(true);
        } else {
          setOpenSnackMessage(true);
          setMessage(response.data!.savePainelCadastroTaxa!);
          setVariantSnack("warning");
        }
      }
    } catch (e) {
    } finally {
      open = false;
      actions.setSubmitting(false);
    }
  };

  const initialValues = {
    codOperadora,
    nomeOperadora,
    taxaCredito: (null as unknown) as string,
    taxaCredito0a6: (null as unknown) as string,
    taxaCredito7a12: (null as unknown) as string,
    taxaDebito: (null as unknown) as string,
    taxaTicket: (null as unknown) as string
  };

  type FormValues = typeof initialValues;
  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        disableBackdropClick={true}
        TransitionComponent={Transition as any}
      >
        <DialogTitle id="form-dialog-title" style={{ marginBottom: 10 }}>
          Taxas
          <Typography variant="subtitle1" gutterBottom>
            Caso exista algum produto ou CNPJ com taxas diferentes, favor entrar em contato com o seu consultor.
          </Typography>
        </DialogTitle>
        <Formik
          initialValues={initialValues}
          onSubmit={save}
          validationSchema={Schema}
          render={(formikBag: FormikProps<FormValues>) => (
            <form autoComplete="new-password" role="presentation" onSubmit={formikBag.handleSubmit}>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} style={{ marginBottom: 15 }}>
                    Operadora: &nbsp;<b>{nomeOperadora}</b>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Field id="taxaCredito" name="taxaCredito" component={FormikCurrencyInput} label="Crédito a vista" />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Field
                      id="taxaCredito0a6"
                      name="taxaCredito0a6"
                      component={FormikCurrencyInput}
                      label="Crédito 0 a 6 parcelas"
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Field
                      id="taxaCredito7a12"
                      name="taxaCredito7a12"
                      component={FormikCurrencyInput}
                      label="Crédito 7 a 12 parcelas"
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Field id="taxaDebito" name="taxaDebito" component={FormikCurrencyInput} label="Débito" />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Field id="taxaTicket" name="taxaTicket" component={FormikCurrencyInput} label="Benéficio" />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="secondary" disabled={formikBag.isSubmitting}>
                  Cancelar
                </Button>
                <Button type="submit" color="primary" disabled={formikBag.isSubmitting}>
                  Salvar
                </Button>
              </DialogActions>
            </form>
          )}
        />
      </Dialog>
      {message.length > 0 && (
        <SnackMessage open={openSnackMessage} close={closeSnackMessage} variant={variantSnack} message={message} />
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: IState) => ({
  ...state
});

const withSavePainelCadastroTaxaMutation = withSavePainelCadastroTaxa<Props>({});

const withMutation = withSavePainelCadastroTaxaMutation(CadastrarTaxas);

const CadastrarTaxasMapped = connect(mapStateToProps, null)(withMutation);

export default CadastrarTaxasMapped as React.ComponentType<Props>;
